
import { basic } from "@/hooks";
class user extends basic {
    constructor() {
        super();
    }
}

export default user;
